import { get, put, post, postForm, del, prepareParams } from "./base";
export { /*upload,*/ download, auth, ERRORS, getConfig, sleep, ErrorWrapper } from "./base";
export const logout = async () => post("/auth/logout");

export const getBackendVersion = async () => get("/options/version");
//export const getFssUrl = async () => get("/options/fss.url");

export const getUsers = async () => get("/users");
export const getUser = async id => get(`/users/${id}`);
export const getUserMe = async () => get("/users/me");
export const putUser = async data => put(`/users/${data.id}`, data);
export const postUser = async data => post("/users", data);
export const deleteUser = async id => del(`/users/${id}`);

// NIC165-463 Скрытие пользователей с ролями Агент и Разработчик
export const getManagedRolesV = async () => get("/managed-roles-v/");

export const getRoles = async () => get("/roles");
export const getRole = async id => get(`/roles/${id}`);
export const putRole = async data => put(`/roles/${data.id}`, data);
export const postRole = async data => post("/roles", data);
export const deleteRole = async id => del(`/roles/${id}`);

export const findSystemLog = async query => get("/event-logs/page", prepareParams(query));
export const getSystemLog = async id => get(`/event-logs/${id}`);
export const getEventGroups = async () => get("/event-groups");

export const getPurchase = async id => get(`/purchases/${id}`);
export const findPurchases = async query => get("/purchases/page", prepareParams(query));
export const loadPurchases = async () => post("/purchases/load");
export const transferPurchases = async (data) => post("/purchases/transfer-to-1c", data);
export const deletePurchase = async id => del(`/purchases/${id}`);

export const getMaterial = async id => get(`/materials/${id}`);
export const findMaterials = async query => get("/materials/page", prepareParams(query));
export const loadMaterials = async () => post("/materials/sync");
export const transferMaterials = async () => post("/materials/transfer-to-1c");

export const findDictionaries = async query => get('/dictionaries/page/', prepareParams(query));
export const getDictionary = async (id) => get(`/dictionaries/${id}`);
export const getDictionaryAttributes = async id => get(`/dictionaries/${id}/attributes`);
export const putDictionaryAttribute = async (id, data) => put(`/dictionaries/${id}/attributes/${data.id}`, data);
export const postDictionaryAttribute = async (id, data) => post(`/dictionaries/${id}/attributes`, data);
export const deleteDictionaryAttribute = async (id, attrId) => del(`/dictionaries/${id}/attributes/${attrId}`);

export const findDictionaryItems = async query => get('/dictionary-items/page', prepareParams(query));
export const getDictionaryItems = async code => get('/dictionary-items/page', prepareParams({
  filterJson: ['dictionary.code', '=', code],
  page: '999,1'
}));
export const getDictionaryItem = async id => get(`/dictionary-items/${id}`);
export const putDictionaryItem = async (id, data) => put(`/dictionary-items/${id}`, data);
export const postDictionaryItem = async (data) => post(`/dictionary-items/`, data);
export const deleteDictionaryItem = async (id) => del(`/dictionary-items/${id}`);

// NIC165-348 Расстановка и просмотр устройств на плане помещения
export const getDictionaryItemDevices = async locationId => get(`/device-part-short-v/${locationId}`);
export const putDictionaryItemDevices = async data => put(`/device-part-short-v/update-coordinates`, data);

export const getDictionaryItemAttributes = async id => get(`/dictionary-items/${id}/attributes`);
export const postDictionaryItemAttributes = async (id, data) => post(`/dictionary-items/${id}/attributes`, data);
export const putDictionaryItemAttributes = async (id, rowId, data) => put(`/dictionary-items/${id}/attributes/${rowId}`, data);
export const deleteDictionaryItemAttributes = async (id, rowId) => del(`/dictionary-items/${id}/attributes/${rowId}`);
// NIC165-331 Флаг "Системный" для атрибутов
export const putDictionaryItemSystemAttributes = async (id, data) => put(`/dictionary-items/${id}/attributes`, data);
// NIC165-327 Добавить расширенную информацию на страницу локации
export const getStatisticsLocationsDevices = async id => get(`/statistics/locations/${id}/devices`);
// NIC165-334 Добавить секцию "План помещений" на страницу локации
export const postfloorPlan = async (dictionaryItemId, data) => post(`/dictionary-items/${dictionaryItemId}/attributes/location`, data);
export const putfloorPlan = async (dictionaryItemId, attributeValueId, data) => put(`/dictionary-items/${dictionaryItemId}/attributes/location/${attributeValueId}`, data);
export const deletefloorPlan = async (dictionaryItemId, attributeValueId) => del(`/dictionary-items/${dictionaryItemId}/attributes/location/${attributeValueId}`);

// NIC165-340 Добавить раздел "Расходные материалы"
export const getConsumables = async query => get(`/device-part-v/page`, prepareParams(query));

// NIC165-503 Добавление режима групповых действий
export const postDevicesChangeActivity = async (activate, data) => post(`/devices/change-activity?activate=${activate}`, data);

export const findSuppliers = async params => get("/suppliers/find", params);
export const getSupplier = async (id) => get(`/suppliers/${id}`);

export const getVersion = async () => get("/options/version/");
export const getBuildVersion = async () => get("/options/build-version/");
export const getStatistics = async (stat, filter) => get(`/statistics-v/${stat}`, { filter: JSON.stringify(filter||{}) });

// NIC165-604 Дашборд
export const getStatisticsV = async () => get("/statistics-v");
export const getStatisticsLocations = async () => get("/statistics-v/locations");
export const getStatisticsDevicesStats = async () => get("/statistics-v/devices");
export const getStatisticsAgentsStats = async () => get("/statistics-v/agents");
export const getStatisticsPrintVolume = async () => get("/statistics-v/print-volume");
export const getStatisticsMostPrintingDevices = async () => get("/statistics-v/most-printing-devices");
export const getStatisticsDayColorCounts = async () => get("/statistics-v/day-print");
export const getAgentsActualVersions = async () => get("/agents/actual-versions");

export const findAssemblies = async query => get("/assemblies/page", prepareParams(query));
export const getAssembly = async id => get(`/assemblies/${id}`);
export const findAssemblyExports = async query => get("/assembly-exports/page", prepareParams(query));
export const postAssemblyExport = async data => post("/assembly-exports/", data);
export const getAssemblyExport = async id => get(`/assembly-exports/${id}`);
export const deleteAssemblyExport = async id => del(`/assembly-exports/${id}`);
export const getAssemblyExportReports = async id => get(`/assembly-exports/${id}/reports`);
export const getAssemblyExportReport = async (exportId, reportId) => get(`/assembly-exports/${exportId}/reports/${reportId}`);
export const transferAssemblyExportReports = async id => post(`/assembly-exports/${id}/transfer-to-1c`);

export const findTransactions = async query => get("/transactions/page", prepareParams(query));
export const getTransaction = async id => get(`/transactions/${id}`);

export const findAssemblyReportItems = async query => get("/assembly-report-items/page", prepareParams(query));

export const getRequirement = async id => get(`/requirements/${id}`);
export const findRequirements = async query => get("/requirements/page", prepareParams(query));
export const loadRequirements = async () => post("/requirements/load");
export const transferRequirements = async (data) => post("/requirements/transfer-to-1c", data);
export const deleteRequirement = async id => del(`/requirements/${id}`);

export const findSales = async query => get("/sales/page", prepareParams(query));
export const getSale = async id => get(`/sales/${id}`);
export const loadSales = async () => post("/sales/load");
export const transferSales = async (data) => post("/sales/transfer-to-1c", data);
export const findCustomers = async params => get("/customers/find", params);
export const getCustomer = async (id) => get(`/customers/${id}`);
export const deleteSale = async id => del(`/sales/${id}`);

export const findOutsourceIn = async query => get("/outsource/in/page", prepareParams(query));
export const loadOutsourceIn = async () => post("/outsource/in/load");
export const transferOutsourceIn = async (data) => post("/outsource/in/transfer-to-1c", data);
export const getOutsourceIn = async id => get(`/outsource/in/${id}`);
export const deleteOutsourceIn = async id => del(`/outsource/in/${id}`);

export const findOutsourceOut = async query => get("/outsource/out/page", prepareParams(query));
export const loadOutsourceOut = async () => post("/outsource/out/load");
export const transferOutsourceOut = async (data) => post("/outsource/out/transfer-to-1c", data);
export const getOutsourceOut = async id => get(`/outsource/out/${id}`);
export const deleteOutsourceOut = async id => del(`/outsource/out/${id}`);

export const findComplectations = async query => get("/complectations/page", prepareParams(query));
export const loadComplectations = async () => post("/complectations/load");
export const transferComplectations = async (data) => post("/complectations/transfer-to-1c", data);
export const getComplectation = async id => get(`/complectations/${id}`);
export const deleteComplectation = async id => del(`/complectations/${id}`);

export const getAvailableAgentsPage = async query => get("/agents-v/page", prepareParams(query));
export const getAvailableAgents = async () => get("/agents-v");
export const getAgent = async id => get(`/agents-v/${id}`);
export const setAgentStatus = async (id, status) => post(`/agents/${id}/status`, { status });
export const putAgent = async (id, data) => put(`/agents/${id}`, data);
export const postAgent = async (data) => post('/agents', data);
export const deleteAgent = async id => del(`/agents/${id}`);

// NIC165-517 Добавление ссылки на агента в карточку локации
export const getLocationAgents = async id => get(`/agents-v/location/${id}`);

// NIC165-85 Настройка расписания опросов
export const getAgentSettings = async id => get(`/agent-settings/agent/${id}`);
export const putAgentSettings = async (id, data) => put(`/agent-settings/${id}`, data);

export const findNetworkRanges = async query => get("/network-ranges-v/page", prepareParams(query));
export const findNetwork = async () => get("/network-ranges-v");
export const getNetworkRange = async id => get(`/network-ranges-v/${id}`);
export const putNetworkRange = async (id, data) => put(`/network-ranges/${id}`, data);
export const postNetworkRange = async (data) => post('/network-ranges', data);
export const deleteNetworkRange = async id => del(`/network-ranges/${id}`);

export const findDeviceDays = async query => get("/dm-device-days-v/page", prepareParams(query));
// NIC165-318 Замена отображения витрин на отображение устройств
export const actualDeviceDays = async query => get("/dm-device-days-actual-v/page", prepareParams(query));
// NIC165-274 Карточка устройства
export const findDeviceResources = async query => get("/dm-device-part-days/page", prepareParams(query));

export const getDeviceDays = async id => get(`/dm-device-days-v/device/${id}/`);
export const putDevice = async (id, data) => put(`/devices/${id}`, data);

// NIC165-234 Удаление устройств
export const deleteDevice = async id => del(`/devices/${id}`);

// http://cronus.nicotech.ru:8888/issue/NIC165-19#focus=Comments-73-35246.0-0
export const versionUpload = async (formData) => postForm('/versions/upload', formData);

// NIC165-404 Инициализация статуса обслуживания по списку устройств
export const enableMaintenance = async (formData) => postForm('/service/set-active-status', formData);
export const disableMaintenance = async (formData) => postForm('/service/set-inactive-status', formData);
export const resetStatusDevice = async (formData) => postForm('/service/reset-status', formData);

// NIC165-62 Device - history & user activity
export const findDeviceUserDays = async query => get("/dm-device-user-days/page", prepareParams(query));
export const findDeviceHistory = async query => get("/dm-device-history/page", prepareParams(query));
// NIC165-170 Мониторинг расходных материалов
export const findDevicePartDaysAll = async id => get(`/dm-device-part-days/device/${id}/all`);
export const findDevicePartDaysInstalled = async id => get(`/dm-device-part-days/device/${id}`);

//NIC165-436 Ограничение видимости по локациям в разделе Пользователи
export const managedUsersPage = async query => get("/managed-users-v/page", prepareParams(query));
export const managedUsers = async () => get("/managed-users-v");

// NIC165-61 Printing queue
export const findQueues = async query => get("/queues-v/page", prepareParams(query));
export const getQueue = async id => get(`/queues-v/${id}`);
export const putQueue = async (id, data) => put(`/queues/${id}`, data);
export const postQueue = async (data) => post('/queues', data);
export const deleteQueue = async id => del(`/queues/${id}`);
export const findQueueJobs = async query => get("/queue-jobs/page", prepareParams(query));

// NIC165-21 Неизвестные устройства
export const updateWalkFile = (id) => post(`/dm-device-days/device/${id}/update-walk`);

//NIC165-125 Уведомления Рассылка уведомлений и отчетов (FE)
export const getNotifications = async () => get('/notifications');
export const getNotification = async id => get(`/notifications/${id}`);
export const putNotification = async (id, data) => put(`/notifications/${id}`, data);
export const postNotification = async (data) => post('/notifications', data);
export const deleteNotification = async id => del(`/notifications/${id}`);
export const getSubscribers = async () => get(`/subscribers`);
export const deleteSubscribers = async id => del(`/subscribers/${id}`);
export const postSubscribers = async data => post("/subscribers/", data);
// NIC165-189 Добавить дефолтных получателей сообщений и кнопку Тест
export const putSubscribersSystem = async data => put("/subscribers/system", data);
export const testSendingNotification = async () => get("/subscribers/system/test");
// NIC165-156 Необработанная ошибка добавления существующего эмейла для подписки
export const findSubscribers = async email => get("/subscribers/page", prepareParams({
  filterJson: ['email', '=', email],
  page: '1,1'
}));
export const testNotification = async (id) => post(`/notifications/${id}/test-email/`);
// NIC165-401 Вопрос пользователю при очистке списка получателей по умолчанию
export const notificationsWithoutSubscribers = async () => get("/notifications/without-subscribers");

// NIC165-456 Ограничение видимости по локациям в разделе Уведомления
export const userNotificationsV = async () => get("/user-notifications-v");
export const userNotificationsVPage = async query => get("/user-notifications-v/page", prepareParams(query));

// NIC165-153 Форма настроек подключения к SMTP-серверу
export const getSettingsSmtp = async () => get('/settings/smtp');
export const putSettings = async (data) => put(`/settings`, data);

// NIC165-85 Настройка расписания опросов
export const getSettingsAll = async () => get('/settings/');

// NIC165-620 Улучшение отображения инфы об ошибках и об окончании лицензии
export const getUserLicensesRelevant = async () => get("/user-licenses-relevant/highest");

// NIC165-185 Добавить раздел "О лицензии"
export const getLicense = async () => get("/instance-license/");

//NIC165-429 Добавить раздел Лицензии
export const userLicenses = async query => get("/user-licenses/page", prepareParams(query));
export const userLicensesRelevant = async () => get('/user-licenses-relevant/');
export const userLocationsManagedLicense = async () => get('/user-locations/managed-license');
export const userLicensesRelevantPage = async query => get('/user-licenses-relevant/page', prepareParams(query));
export const getLocationDevices = async (id) => get(`/location-devices-v/${id}`);
export const getUserLicenses = async (id) => get(`/user-licenses/${id}`);
export const postLicenses = async (data) => post('/licenses', data);
export const putLicenses = async (id, data) => put(`/licenses/${id}`, data);
export const deleteLicenses = async id => del(`/licenses/${id}`);

// NIC165-211 Отчет по доступным устройствам
export const getDeviceAvailability = async filter => get("/reports/device-availability", { filter: JSON.stringify(filter || {}) });
export const getDeviceCounters = async filter => get("/reports/device-counters", { filter: JSON.stringify(filter || {}) });
export const getPartReplacements = async filter => get("/reports/part-replacements", { filter: JSON.stringify(filter || {}) });
// NIC165-341 Добавить отчет "Установленные расходные материалы"
export const getInstalledСonsumables = async filter => get("/reports/installed-consumables/", { filter: JSON.stringify(filter || {}) });

// NIC165-258 Хранение отчетов и их метаданных в БД
export const getReportsType = async () => get("/reports/");

// NIC165-260 Ограничение доступа пользователей по локациям
export const getUserLocations = async () => get("/user-locations/");
export const getUserLocationsPage = async query => get("/user-locations/page", prepareParams(query));

// NIC165-260 Ограничение доступа пользователей по локациям
// export const getAvailableAgents = async () => get("/network-ranges-v/agents/");

// NIC165-433 Обязательность e-mail для пользователя в облачном режиме
export const getIsCloudMode = async () => get("/options/cloud-mode.enabled");

// NIC165-476 Хранение файлов инструкций и инсталляторов Агента
export const getManualsAndInstallersFiles = async () => get("/options/files/");
export const downloadFiles = async (fileName) => get(`/options/files/${fileName}/download/`);

// NIC165-478 Эндпоинт для оповещения агентов
export const notifyingAgents = async () => post('/agents/notify-all/UPDATE_VERSION');